// @flow

/**
 * PWR Distribution client IDs - fallback list when distribution API fails
 */
export const PWR_DISTRO_CLIENT_IDS: number[] = [
  12846,
  164195141,
  1986404165,
  380979969,
  1901388221,
  49047,
  132953563,
  1778600120,
  15040,
  47397,
  77922,
  49156,
  17365,
  48814,
];

/**
 * Channels that always use standard endpoint regardless of client distribution status
 */
export const STANDARD_ENDPOINT_CHANNELS: string[] = [
  'AssignedReview',
  'AssignedQnA',
];

/**
 * Determines if a channel should use pwr-distro endpoint
 */
export const shouldUsePwrDistroEndpoint = (
  channelName: string,
  isPwrDistro?: boolean,
  isWorklist?: boolean
): boolean => {
  if (!isPwrDistro || isWorklist) {
    return false;
  }
  return !STANDARD_ENDPOINT_CHANNELS.includes(channelName);
};



// WEBPACK FOOTER //
// ./src/config/pwrDistroClientIds.js